import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import { RhToastContainer } from '@rhythm-ui/react';
import App from './App';
import { store } from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RhToastContainer autoClose={1000} pauseOnHover hideProgressBar />
      <App />
    </Provider>
  </React.StrictMode>,
);
